import { useUpdateAppointmentCollection } from '@/hooks/use-update-appointment-collection.ts';

import { showErrorNotification } from '@/services/notificationService.ts';

import { useBookingStore } from '@/stores/bookingStore.ts';

export const useUpdateCollectionWithGuard = (onComplete?: () => void) => {
    const { updateCollection } = useUpdateAppointmentCollection();
    const editingCollectionId = useBookingStore((state) => state.editingCollectionId);

    return (sendNotification: boolean): void => {
        if (!editingCollectionId) {
            showErrorNotification('Die Terminserie konnte nicht aktualisiert werden.');
            return;
        }
        void updateCollection(editingCollectionId, onComplete, sendNotification);
    };
};
